import React, { useState, useEffect, useRef, useCallback } from 'react';
const useWindowWidth = () => {
  const [w, setW] = React.useState(window.innerWidth);
  useEffect(() => { const h = () => setW(window.innerWidth); window.addEventListener('resize', h); return () => window.removeEventListener('resize', h); }, []);
  return w;
};
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useLanguage } from '../context/LanguageContext';
import { attorneyAPI, articleAPI, messageAPI, savedAttorneyAPI } from '../services/api';
import PhoneInput from '../components/common/PhoneInput';
import { CASE_CATEGORIES } from '../constants/caseCategories';
import { displayLocation } from '../utils/locationUtils';

const getParentCategories = (practiceAreas) => {
  const parents = new Set();
  for (const area of practiceAreas) {
    const parent = CASE_CATEGORIES.find(cat => cat.subs.includes(area) || cat.label === area);
    if (parent) parents.add(parent.label);
  }
  return [...parents];
};

const SERVER_URL = (process.env.REACT_APP_API_URL || 'http://localhost:5000/api').replace('/api', '');

const REGION_SUBREGIONS = {
  tashkent_city: [
    { label: 'Юнусобод тумани',      value: 'Юнусабадский район' },
    { label: 'Чилонзор тумани',      value: 'Чиланзарский район' },
    { label: 'Мирзо-Улугбек тумани', value: 'Мирзо-Улугбекский район' },
    { label: 'Яккасарой тумани',     value: 'Яккасарайский район' },
    { label: 'Шайхонтоҳур тумани',   value: 'Шайхантахурский район' },
    { label: 'Олмазор тумани',       value: 'Алмазарский район' },
    { label: 'Учтепа тумани',        value: 'Учтепинский район' },
    { label: 'Сергели тумани',       value: 'Сергелийский район' },
    { label: 'Бектемир тумани',      value: 'Бектемирский район' },
  ],
  tashkent: [
    { label: 'Нурафшон шаҳри',      value: 'г. Нурафшон' },
    { label: 'Чирчиқ шаҳри',        value: 'г. Чирчик' },
    { label: 'Олмалиқ шаҳри',       value: 'г. Алмалык' },
    { label: 'Ангрен шаҳри',        value: 'г. Ангрен' },
    { label: 'Бекобод шаҳри',       value: 'г. Бекабад' },
    { label: 'Янгийўл шаҳри',       value: 'г. Янгиюль' },
    { label: 'Зангиота тумани',     value: 'Зангиатинский район' },
    { label: 'Қибрай тумани',       value: 'Кибрайский район' },
    { label: 'Бўстонлиқ тумани',    value: 'Бостанлыкский район' },
    { label: 'Бўка тумани',         value: 'Букинский район' },
    { label: 'Паркент тумани',      value: 'Паркентский район' },
    { label: 'Пскент тумани',       value: 'Пскентский район' },
    { label: 'Тошкент тумани',      value: 'Ташкентский район' },
    { label: 'Ўртачирчиқ тумани',   value: 'Уртачирчикский район' },
    { label: 'Юқоричирчиқ тумани',  value: 'Юкоричирчикский район' },
    { label: 'Оҳангарон шаҳри',     value: 'г. Охангарон' },
    { label: 'Чиноз тумани',        value: 'Чиназский район' },
    { label: 'Оққўрғон тумани',     value: 'Аккурганский район' },
    { label: 'Қуйи Чирчиқ тумани', value: 'Куйичирчикский район' },
  ],
  andijan: [
    { label: 'Андижон шаҳри',        value: 'г. Андижан' },
    { label: 'Андижон тумани',       value: 'Андижанский район' },
    { label: 'Асака тумани',         value: 'Асакинский район' },
    { label: 'Балиқчи тумани',       value: 'Балыкчинский район' },
    { label: 'Булоқбоши тумани',     value: 'Булакбашский район' },
    { label: 'Бўстон тумани',        value: 'Бустанский район' },
    { label: 'Жалақудуқ тумани',     value: 'Джалалкудукский район' },
    { label: 'Избоскан тумани',      value: 'Избасканский район' },
    { label: 'Мархамат тумани',      value: 'Мархаматский район' },
    { label: 'Олтинкўл тумани',      value: 'Алтыкульский район' },
    { label: 'Пахтаобод тумани',     value: 'Пахтаабадский район' },
    { label: 'Қўрғонтепа тумани',    value: 'Кургантепинский район' },
    { label: 'Улуғнор тумани',       value: 'Улугнорский район' },
    { label: 'Хонобод тумани',       value: 'Ханабадский район' },
    { label: 'Хўжаобод тумани',      value: 'Ходжаабадский район' },
    { label: 'Шаҳрихон тумани',      value: 'Шахриханский район' },
  ],
  fergana: [
    { label: 'Фарғона шаҳри',       value: 'г. Фергана' },
    { label: 'Қўқон шаҳри',         value: 'г. Коканд' },
    { label: 'Марғилон шаҳри',      value: 'г. Маргилан' },
    { label: 'Қувасой шаҳри',       value: 'г. Кувасай' },
    { label: 'Қува тумани',         value: 'Кувинский район' },
    { label: 'Риштон тумани',       value: 'Риштанский район' },
    { label: 'Бағдод тумани',       value: 'Багдадский район' },
    { label: 'Бешариқ тумани',      value: 'Бешарыкский район' },
    { label: 'Бувайда тумани',       value: 'Бувайдинский район' },
    { label: 'Данғара тумани',       value: 'Дангаринский район' },
    { label: 'Қуштепа тумани',       value: 'Куштепинский район' },
    { label: 'Сўх тумани',           value: 'Сохский район' },
    { label: 'Тошлоқ тумани',        value: 'Ташлакский район' },
    { label: 'Фурқат тумани',        value: 'Фуркатский район' },
    { label: 'Ёзёвон тумани',        value: 'Язяванский район' },
  ],
  namangan: [
    { label: 'Наманган шаҳри',        value: 'г. Наманган' },
    { label: 'Чуст тумани',          value: 'Чустский район' },
    { label: 'Поп тумани',           value: 'Папский район' },
    { label: 'Косонсой тумани',      value: 'Касансайский район' },
    { label: 'Давлатобод тумани',    value: 'Давлатабадский район' },
    { label: 'Мингбулоқ тумани',     value: 'Мингбулакский район' },
    { label: 'Норин тумани',         value: 'Норинский район' },
    { label: 'Тўрақўрғон тумани',    value: 'Туракурганский район' },
    { label: 'Уйчи тумани',          value: 'Уйчинский район' },
    { label: 'Учқўрғон тумани',      value: 'Учкурганский район' },
    { label: 'Янгиқўрғон тумани',    value: 'Янгикурганский район' },
    { label: 'Янги Наманган тумани', value: 'Янги-Наманганский район' },
    { label: 'Чортоқ тумани',        value: 'Чартакский район' },
  ],
  samarkand: [
    { label: 'Самарқанд шаҳри',     value: 'г. Самарканд' },
    { label: 'Каттақўрғон шаҳри',   value: 'г. Каттакурган' },
    { label: 'Ургут тумани',        value: 'Ургутский район' },
    { label: 'Пайариқ тумани',      value: 'Пайарыкский район' },
    { label: 'Иштихон тумани',      value: 'Иштиханский район' },
    { label: 'Жомбой тумани',       value: 'Джамбайский район' },
    { label: 'Оқдарё тумани',       value: 'Акдарьинский район' },
    { label: 'Булунғур тумани',     value: 'Булунгурский район' },
    { label: 'Қўшрабод тумани',     value: 'Кошрабадский район' },
    { label: 'Нарпай тумани',       value: 'Нарпайский район' },
    { label: 'Нуробод тумани',      value: 'Нурабадский район' },
    { label: 'Пастдарғом тумани',   value: 'Пастдаргомский район' },
    { label: 'Пахтачи тумани',      value: 'Пахтачийский район' },
    { label: 'Тайлоқ тумани',       value: 'Тайлакский район' },
  ],
  bukhara: [
    { label: 'Бухоро шаҳри',        value: 'г. Бухара' },
    { label: 'Когон тумани',         value: 'г. Каган' },
    { label: 'Ромитан тумани',      value: 'Ромитанский район' },
    { label: 'Қоракўл тумани',      value: 'Каракульский район' },
    { label: 'Ғиждувон тумани',     value: 'Гиждуванский район' },
    { label: 'Вобкент тумани',      value: 'Вабкентский район' },
    { label: 'Жондор тумани',       value: 'Джандарский район' },
    { label: 'Қоровулбозор тумани', value: 'Каравулбазарский район' },
    { label: 'Олот тумани',         value: 'Алатский район' },
    { label: 'Пешку тумани',        value: 'Пешкунский район' },
    { label: 'Шофиркон тумани',     value: 'Шафирканский район' },
  ],
  navoi: [
    { label: 'Навоий шаҳри',        value: 'г. Навои' },
    { label: 'Зарафшон шаҳри',      value: 'г. Зарафшан' },
    { label: 'Учқудуқ тумани',      value: 'Учкудукский район' },
    { label: 'Нурота тумани',       value: 'Нуратинский район' },
    { label: 'Ғозғон шаҳри',        value: 'Газганский район' },
    { label: 'Конимех тумани',      value: 'Конимехский район' },
    { label: 'Кармана тумани',      value: 'Карманинский район' },
    { label: 'Қизилтепа тумани',    value: 'Кызылтепинский район' },
    { label: 'Навбаҳор тумани',     value: 'Навбахорский район' },
    { label: 'Томди тумани',        value: 'Томдинский район' },
    { label: 'Хатирчи тумани',      value: 'Хатырчинский район' },
  ],
  kashkadarya: [
    { label: 'Қарши шаҳри',         value: 'г. Карши' },
    { label: 'Шаҳрисабз шаҳри',     value: 'г. Шахрисабз' },
    { label: 'Қарши тумани',        value: 'Каршинский район' },
    { label: 'Китоб тумани',        value: 'Китабский район' },
    { label: 'Кўкдала тумани',      value: 'Кукдалинский район' },
    { label: 'Косон тумани',        value: 'Касанский район' },
    { label: 'Муборак тумани',      value: 'Мубарекский район' },
    { label: 'Миришкор тумани',     value: 'Миришкорский район' },
    { label: 'Ғузор тумани',        value: 'Гузарский район' },
    { label: 'Деҳқонобод тумани',   value: 'Дехканабадский район' },
    { label: 'Қамаши тумани',       value: 'Камашинский район' },
    { label: 'Қасби тумани',        value: 'Касбинский район' },
    { label: 'Нишон тумани',        value: 'Нишанский район' },
    { label: 'Чироқчи тумани',      value: 'Чиракчинский район' },
    { label: 'Яккабоғ тумани',      value: 'Яккабагский район' },
  ],
  surkhandarya: [
    { label: 'Термиз шаҳри',        value: 'г. Термез' },
    { label: 'Ангор тумани',        value: 'Ангорский район' },
    { label: 'Денов тумани',        value: 'Денауский район' },
    { label: 'Шеробод тумани',      value: 'Шерабадский район' },
    { label: 'Бойсун тумани',       value: 'Байсунский район' },
    { label: 'Бандихон тумани',     value: 'Бандиханский район' },
    { label: 'Жарқўрғон тумани',    value: 'Джаркурганский район' },
    { label: 'Қизириқ тумани',      value: 'Кизирикский район' },
    { label: 'Қумқўрғон тумани',    value: 'Кумкурганский район' },
    { label: 'Музработ тумани',     value: 'Музрабадский район' },
    { label: 'Олтинсой тумани',     value: 'Алтынсайский район' },
    { label: 'Сариосиё тумани',     value: 'Сариасийский район' },
    { label: 'Узун тумани',         value: 'Узунский район' },
    { label: 'Шўрчи тумани',        value: 'Шурчинский район' },
  ],
  jizzakh: [
    { label: 'Жиззах шаҳри',        value: 'г. Джизак' },
    { label: 'Зомин тумани',        value: 'Заминский район' },
    { label: 'Ғаллаорол тумани',    value: 'Галляаральский район' },
    { label: 'Янгиобод тумани',     value: 'Янгиабадский район' },
    { label: 'Арнасой тумани',      value: 'Арнасайский район' },
    { label: 'Бахмал тумани',       value: 'Бахмалский район' },
    { label: 'Дўстлик тумани',      value: 'Дустликский район' },
    { label: 'Зарбдор тумани',      value: 'Зарбдарский район' },
    { label: 'Зафаробод тумани',    value: 'Зафарабадский район' },
    { label: 'Мирзачўл тумани',     value: 'Мирзачульский район' },
    { label: 'Пахтакор тумани',     value: 'Пахтакорский район' },
    { label: 'Фориш тумани',        value: 'Фаришский район' },
    { label: 'Шароф Рашидов тумани',value: 'Шараф-Рашидовский район' },
  ],
  sirdarya: [
    { label: 'Гулистон шаҳри',      value: 'г. Гулистан' },
    { label: 'Янгиер шаҳри',        value: 'г. Янгиер' },
    { label: 'Хавос тумани',        value: 'Хавастский район' },
    { label: 'Сардоба тумани',      value: 'Сардобинский район' },
    { label: 'Оқолтин тумани',      value: 'Акалтынский район' },
    { label: 'Боёвут тумани',       value: 'Баяутский район' },
    { label: 'Мирзаобод тумани',    value: 'Мирзаабадский район' },
    { label: 'Сайхунобод тумани',   value: 'Сайхунабадский район' },
    { label: 'Ширин шаҳри',         value: 'г. Ширин' },
    { label: 'Сирдарё тумани',      value: 'Сырдарьинский район' },
  ],
  khorezm: [
    { label: 'Урганч шаҳри',        value: 'г. Ургенч' },
    { label: 'Хива шаҳри',          value: 'г. Хива' },
    { label: 'Питнак шаҳри',        value: 'г. Питнак' },
    { label: 'Хонқа тумани',        value: 'Ханкинский район' },
    { label: 'Шовот тумани',        value: 'Шаватский район' },
    { label: 'Боғот тумани',        value: 'Багатский район' },
    { label: 'Гурлан тумани',       value: 'Гурленский район' },
    { label: 'Қўшкўпир тумани',     value: 'Кушкупырский район' },
    { label: 'Хазорасп тумани',     value: 'Хазараспский район' },
    { label: 'Янгиариқ тумани',     value: 'Янгиарыкский район' },
    { label: 'Янгибозор тумани',    value: 'Янгибазарский район' },
  ],
  karakalpakstan: [
    { label: 'Нукус шаҳри',         value: 'г. Нукус' },
    { label: 'Тахиатош шаҳри',      value: 'г. Тахиаташ' },
    { label: 'Тўрткўл шаҳри',       value: 'г. Турткуль' },
    { label: 'Хўжайли шаҳри',       value: 'г. Ходжейли' },
    { label: 'Чимбой шаҳри',        value: 'г. Чимбай' },
    { label: 'Беруний тумани',      value: 'Берунийский район' },
    { label: 'Қўнғирот тумани',     value: 'Кунградский район' },
    { label: 'Амударё тумани',      value: 'Амударьинский район' },
    { label: 'Кегейли тумани',      value: 'Кегейлийский район' },
    { label: 'Қонликўл тумани',     value: 'Канликольский район' },
    { label: 'Мўйноқ тумани',       value: 'Муйнакский район' },
    { label: 'Тахиатош тумани',     value: 'Тахиатошский район' },
    { label: 'Тахтакўпир тумани',   value: 'Тахтакупырский район' },
    { label: 'Шўманай тумани',      value: 'Шуманайский район' },
    { label: 'Элликқалъа тумани',   value: 'Элликкалинский район' },
  ],
};

// Flat map: sub.value → sub.label for display
const SUBLABEL_BY_VALUE = {};
Object.values(REGION_SUBREGIONS).forEach(subs =>
  subs.forEach(s => { SUBLABEL_BY_VALUE[s.value] = s.label; })
);

const REGION_KEYS = Object.keys(REGION_SUBREGIONS);

const LocationSelect = ({ value, onChange, inputStyle, t }) => {
  const [open, setOpen] = useState(false);
  const [expanded, setExpanded] = useState(null);
  const ref = useRef(null);

  useEffect(() => {
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const displayLabel = value
    ? (SUBLABEL_BY_VALUE[value] || value)
    : 'Ҳудудни танланг';

  return (
    <div ref={ref} style={{ position: 'relative' }}>
      <button
        type="button"
        onClick={() => setOpen(o => !o)}
        style={{
          ...inputStyle,
          display: 'flex', justifyContent: 'space-between', alignItems: 'center',
          cursor: 'pointer', backgroundColor: 'white', textAlign: 'left',
          color: value ? '#2d3748' : '#a0aec0',
        }}
      >
        <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{displayLabel}</span>
        <svg width="10" height="6" viewBox="0 0 10 6" style={{ opacity: 0.5, flexShrink: 0, marginLeft: '0.5rem' }}>
          <path d="M1 1l4 4 4-4" stroke="#718096" strokeWidth="1.5" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </button>
      {open && (
        <div style={{
          position: 'absolute', top: 'calc(100% + 4px)', left: 0, right: 0,
          backgroundColor: 'white', borderRadius: '10px',
          boxShadow: '0 8px 32px rgba(0,0,0,0.14)', border: '1px solid #e2e8f0',
          zIndex: 1000, maxHeight: '280px', overflowY: 'auto', padding: '0.4rem 0',
        }}>
          {REGION_KEYS.map(key => (
            <div key={key}>
              <div
                onClick={() => setExpanded(e => e === key ? null : key)}
                style={{
                  padding: '0.6rem 1rem', fontSize: '0.95rem', cursor: 'pointer',
                  fontWeight: '600', color: '#1a365d',
                  backgroundColor: expanded === key ? '#ebf8ff' : 'transparent',
                  display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                }}
              >
                {t(`regions.${key}`)}
                <svg width="8" height="5" viewBox="0 0 10 6" style={{ opacity: 0.5, transform: expanded === key ? 'rotate(180deg)' : 'none' }}>
                  <path d="M1 1l4 4 4-4" stroke="#718096" strokeWidth="1.5" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              {expanded === key && REGION_SUBREGIONS[key].map(sub => (
                <div
                  key={sub.value}
                  onClick={() => { onChange(sub.value); setOpen(false); setExpanded(null); }}
                  style={{
                    padding: '0.5rem 1rem 0.5rem 1.75rem', fontSize: '0.9rem', cursor: 'pointer',
                    color: value === sub.value ? '#2b6cb0' : '#4a5568',
                    fontWeight: value === sub.value ? '600' : '400',
                    backgroundColor: value === sub.value ? '#ebf8ff' : 'transparent',
                  }}
                >
                  {sub.label}
                </div>
              ))}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

const ARTICLE_STATUS_LABELS = {
  draft: 'Қоралама',
  pending_review: 'Кўриб чиқилмоқда',
  published: 'Чоп этилган',
  rejected: 'Рад этилган',
};

const ARTICLE_STATUS_STYLES = {
  draft: { color: '#718096', backgroundColor: '#f1f5f9' },
  pending_review: { color: '#b7791f', backgroundColor: '#fefcbf' },
  published: { color: '#276749', backgroundColor: '#c6f6d5' },
  rejected: { color: '#c53030', backgroundColor: '#fed7d7' },
};

const EDIT_PENDING_STYLE = { color: '#b7791f', backgroundColor: '#fefcbf' };

const styles = {
  container: { maxWidth: '1200px', margin: '0 auto', padding: '2rem' },
  header: { marginBottom: '2rem' },
  title: { fontSize: '2rem', fontWeight: '700', color: '#1a365d', marginBottom: '0.5rem' },
  subtitle: { color: '#718096', fontSize: '1rem' },
  grid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '1.5rem', marginBottom: '2rem' },
  statCard: { backgroundColor: 'white', borderRadius: '12px', padding: '1.5rem', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' },
  statValue: { fontSize: '2.5rem', fontWeight: '700', color: '#1a365d', marginBottom: '0.25rem' },
  statLabel: { color: '#718096', fontSize: '0.9rem' },
  section: { backgroundColor: 'white', borderRadius: '12px', padding: '1.5rem', boxShadow: '0 2px 4px rgba(0,0,0,0.1)', marginBottom: '1.5rem' },
  sectionTitle: { fontSize: '1.25rem', fontWeight: '600', color: '#1a365d', marginBottom: '1rem', paddingBottom: '0.75rem', borderBottom: '1px solid #e2e8f0' },
  subscriptionBanner: { backgroundColor: '#fef3c7', border: '1px solid #f59e0b', borderRadius: '12px', padding: '1.5rem', marginBottom: '1.5rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
  subscriptionActive: { backgroundColor: '#c6f6d5', border: '1px solid #38a169' },
  bannerText: { color: '#92400e' },
  bannerTextActive: { color: '#276749' },
  subscribeButton: { backgroundColor: '#f59e0b', color: 'white', padding: '0.75rem 1.5rem', border: 'none', borderRadius: '8px', fontWeight: '600', cursor: 'pointer', textDecoration: 'none' },
  profileSection: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' },
  profileItem: { padding: '0.75rem', backgroundColor: '#f7fafc', borderRadius: '8px' },
  profileLabel: { fontSize: '0.7rem', color: '#718096', textTransform: 'uppercase', letterSpacing: '0.03em', marginBottom: '0.25rem' },
  profileValue: { fontWeight: '500', color: '#2d3748' },
  caseItem: { padding: '1rem', borderBottom: '1px solid #e2e8f0' },
  caseTitle: { fontWeight: '500', color: '#2d3748', marginBottom: '0.25rem' },
  caseMeta: { fontSize: '0.85rem', color: '#718096' },
  badge: { display: 'inline-block', padding: '0.25rem 0.75rem', borderRadius: '12px', fontSize: '0.75rem', fontWeight: '600', marginLeft: '0.5rem' },
  badgeOpen: { backgroundColor: '#c6f6d5', color: '#276749' },
  emptyState: { textAlign: 'center', padding: '2rem', color: '#718096' },
  practiceAreas: { display: 'flex', flexWrap: 'wrap', gap: '0.5rem' },
  practiceTag: { backgroundColor: '#ebf8ff', color: '#2b6cb0', padding: '0.25rem 0.75rem', borderRadius: '12px', fontSize: '0.85rem' },
  input: { padding: '0.75rem 1rem', border: '1px solid #e2e8f0', borderRadius: '8px', fontSize: '1rem', outline: 'none', width: '100%', boxSizing: 'border-box' },
  textarea: { padding: '0.75rem 1rem', border: '1px solid #e2e8f0', borderRadius: '8px', fontSize: '1rem', outline: 'none', minHeight: '100px', resize: 'vertical', fontFamily: 'inherit', width: '100%', boxSizing: 'border-box' },
  checkboxContainer: { display: 'flex', flexWrap: 'wrap', gap: '0.5rem', marginTop: '0.25rem' },
  checkboxLabel: { display: 'flex', alignItems: 'center', gap: '0.25rem', padding: '0.4rem 0.75rem', border: '1px solid #e2e8f0', borderRadius: '6px', fontSize: '0.85rem', cursor: 'pointer' },
  checkboxLabelActive: { backgroundColor: '#ebf8ff', borderColor: '#3182ce', color: '#3182ce' },
};

const AttorneyDashboard = () => {
  const { profile, refreshProfile } = useAuth();
  const { t } = useLanguage();
  const isMobile = useWindowWidth() < 768;
  const [subscription, setSubscription] = useState(null);
  const [viewStats, setViewStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [editing, setEditing] = useState(false);
  const [editData, setEditData] = useState({});
  const [saving, setSaving] = useState(false);
  const [saveError, setSaveError] = useState('');
  const [avatarHover, setAvatarHover] = useState(false);
  const [avatarUploading, setAvatarUploading] = useState(false);
  const [avatarError, setAvatarError] = useState('');
  const [localPicture, setLocalPicture] = useState(null);
  const [editingInfo, setEditingInfo] = useState(false);
  const [infoData, setInfoData] = useState({});
  const [savingInfo, setSavingInfo] = useState(false);
  const [infoSaveError, setInfoSaveError] = useState('');
  const [myArticles, setMyArticles] = useState([]);
  const [articlesLoading, setArticlesLoading] = useState(true);
  const [unreadMsgCount, setUnreadMsgCount] = useState(0);
  const [savedCount, setSavedCount] = useState(null);
  const [showHiddenPopup, setShowHiddenPopup] = useState(false);
  const fileInputRef = useRef(null);

  useEffect(() => {
    if (profile?.hidden) setShowHiddenPopup(true);
  }, [profile?.hidden]);

  useEffect(() => {
    fetchData();
    fetchArticles();
    messageAPI.getAttorneyUnreadCount().then(res => setUnreadMsgCount(res.data?.count || 0)).catch(() => {});
    savedAttorneyAPI.getMyCount().then(res => setSavedCount(res.data?.count ?? 0)).catch(() => setSavedCount(0));
  }, []);

  const fetchArticles = async () => {
    try {
      const res = await articleAPI.listMine();
      setMyArticles(res.data);
    } catch (error) {
      console.error('Error fetching articles:', error);
    } finally {
      setArticlesLoading(false);
    }
  };

  const handleDeleteArticle = async (id) => {
    if (!window.confirm('Мақолани ўчиришни тасдиқлайсизми?')) return;
    try {
      await articleAPI.remove(id);
      setMyArticles((prev) => prev.filter((a) => a.id !== id));
    } catch (error) {
      window.alert(error.response?.data?.error || 'Ўчиришда хатолик юз берди');
    }
  };

  const fetchData = async () => {
    try {
      const subRes = await attorneyAPI.getSubscriptionStatus().catch(() => ({ data: { isSubscribed: false } }));
      setSubscription(subRes.data);
      const viewsRes = await attorneyAPI.getViewStats().catch(() => ({ data: null }));
      setViewStats(viewsRes.data);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleAvatarUpload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setAvatarUploading(true);
    setAvatarError('');
    try {
      const res = await attorneyAPI.uploadProfilePicture(file);
      setLocalPicture(res.data.profilePicture);
      await refreshProfile();
    } catch (err) {
      const msg = err.response?.data?.error || err.message || 'Ошибка загрузки';
      setAvatarError(msg);
      console.error('Avatar upload failed', err);
    } finally {
      setAvatarUploading(false);
      e.target.value = '';
    }
  };

  const startEditing = () => {
    setEditData({
      fullName: profile?.full_name || '',
      phone: profile?.phone || '',
      location: profile?.location || '',
      barNumber: profile?.bar_number || '',
      yearsOfExperience: profile?.years_of_experience || '',
      practiceAreas: profile?.practice_areas || [],
      bio: profile?.bio || '',
    });
    setSaveError('');
    setEditing(true);
  };

  const handleEditChange = (e) => {
    setEditData(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const togglePracticeArea = (key) => {
    setEditData(prev => ({
      ...prev,
      practiceAreas: prev.practiceAreas.includes(key)
        ? prev.practiceAreas.filter(a => a !== key)
        : [...prev.practiceAreas, key],
    }));
  };

  const handleSave = async (e) => {
    e?.preventDefault();
    setSaving(true);
    setSaveError('');
    try {
      await attorneyAPI.updateProfile(editData);
      await refreshProfile();
      setEditing(false);
    } catch (err) {
      setSaveError(err.response?.data?.error || 'Ошибка сохранения');
    } finally {
      setSaving(false);
    }
  };

  const startEditingInfo = () => {
    const specs = profile?.specializations || [];
    setInfoData({
      publishedArticles: profile?.published_articles || [],
      legalAdvice: profile?.legal_advice || [],
      courtCasesCount: profile?.court_cases_count ?? '',
      workplaceBefore: profile?.workplace_before || '',
      specializations: [0, 1, 2].map(i => specs[i] || ''),
      socialMediaLinks: profile?.social_media_links || [],
    });
    setInfoSaveError('');
    setEditingInfo(true);
  };

  const handleInfoFieldChange = (e) => {
    setInfoData(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const updateSpecialization = (idx, value) => {
    setInfoData(prev => ({
      ...prev,
      specializations: prev.specializations.map((s, i) => (i === idx ? value : s)),
    }));
  };

  const addListItem = (field) => {
    setInfoData(prev => ({ ...prev, [field]: [...prev[field], { title: '', link: '' }] }));
  };

  const removeListItem = (field, idx) => {
    setInfoData(prev => ({ ...prev, [field]: prev[field].filter((_, i) => i !== idx) }));
  };

  const updateListItem = (field, idx, key, value) => {
    setInfoData(prev => ({
      ...prev,
      [field]: prev[field].map((item, i) => (i === idx ? { ...item, [key]: value } : item)),
    }));
  };

  const handleSaveInfo = async (e) => {
    e?.preventDefault();
    setSavingInfo(true);
    setInfoSaveError('');
    try {
      await attorneyAPI.updateProfile(infoData);
      await refreshProfile();
      setEditingInfo(false);
    } catch (err) {
      setInfoSaveError(err.response?.data?.error || 'Ошибка сохранения');
    } finally {
      setSavingInfo(false);
    }
  };

  if (loading) return <div style={styles.container}>Loading...</div>;

  return (
    <div style={styles.container}>
      {showHiddenPopup && (
        <div style={{
          position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.45)',
          display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000,
        }}>
          <div style={{
            backgroundColor: 'white', borderRadius: '16px', padding: '2.5rem 2rem',
            maxWidth: '440px', width: '90%', textAlign: 'center',
            boxShadow: '0 8px 40px rgba(0,0,0,0.18)',
          }}>
            <div style={{ marginBottom: '1rem' }}>
              <svg width="56" height="56" viewBox="0 0 24 24" fill="none" stroke="#d69e2e" strokeWidth="2.2"
                strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="13"/><line x1="12" y1="16" x2="12.01" y2="16"/>
              </svg>
            </div>
            <h2 style={{ fontSize: '1.3rem', fontWeight: '800', color: '#1a365d', marginBottom: '0.75rem' }}>
              Профилингиз вақтинча яширилган
            </h2>
            <p style={{ fontSize: '0.95rem', color: '#4a5568', lineHeight: '1.65', marginBottom: '1.5rem' }}>
              Профилингиз ҳозирда сайтда мижозларга кўринмайди. Уни қайта фаоллаштириш учун барча
              маълумотларни (Ф.И.Ш, малака рақами, амалиёт соҳалари, жойлашув, тажриба, био) тўлиқ
              киритинг.
            </p>
            <div style={{ display: 'flex', gap: '0.75rem', justifyContent: 'center' }}>
              <button
                onClick={() => { setShowHiddenPopup(false); startEditing(); }}
                style={{
                  backgroundColor: '#1a365d', color: 'white', border: 'none',
                  padding: '0.8rem 1.75rem', borderRadius: '10px', fontSize: '0.95rem',
                  fontWeight: '600', cursor: 'pointer',
                }}
              >
                Маълумотларни тўлдириш
              </button>
              <button
                onClick={() => setShowHiddenPopup(false)}
                style={{
                  backgroundColor: '#edf2f7', color: '#1a365d', border: 'none',
                  padding: '0.8rem 1.5rem', borderRadius: '10px', fontSize: '0.95rem',
                  fontWeight: '600', cursor: 'pointer',
                }}
              >
                Ёпиш
              </button>
            </div>
          </div>
        </div>
      )}

      <div style={styles.header}>
        <h1 style={styles.title}>{t('dashboard.welcome')}, {profile?.full_name || t('dashboard.attorney')}</h1>
        <p style={styles.subtitle}>{t('dashboard.manageProfile')}</p>
      </div>

      <div style={styles.grid}>
        <div style={styles.statCard}>
          <div style={styles.statValue}>{savedCount ?? '—'}</div>
          <div style={styles.statLabel}>Сизни сақлаган мижозлар</div>
        </div>
      </div>

      {/* View Stats Section */}
      {viewStats && (
        <>
          <div style={styles.grid}>
            <div style={styles.statCard}>
              <div style={styles.statValue}>{viewStats.profileViews}</div>
              <div style={styles.statLabel}>Профил кўришлари</div>
            </div>
            {viewStats.articles?.length > 0 && (
              <div style={styles.statCard}>
                <div style={styles.statValue}>
                  {viewStats.articles.reduce((sum, a) => sum + a.views, 0)}
                </div>
                <div style={styles.statLabel}>Мақолалар кўришлари</div>
              </div>
            )}
          </div>

          {viewStats.articles?.length > 0 && (
            <div style={styles.section}>
              <h2 style={{ fontSize: '1.1rem', fontWeight: '600', color: '#1a365d', marginBottom: '1rem' }}>Мақолалар бўйича кўришлар</h2>
              {viewStats.articles.map(article => (
                <div
                  key={article.slug}
                  style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '0.75rem 0', borderBottom: '1px solid #e2e8f0' }}
                >
                  <a href={article.url} target="_blank" rel="noopener noreferrer" style={{ color: '#3182ce', textDecoration: 'none', fontSize: '0.95rem' }}>
                    {article.title}
                  </a>
                  <span style={{ fontWeight: '700', color: '#1a365d', fontSize: '1.1rem', marginLeft: '1rem', whiteSpace: 'nowrap' }}>
                    {article.views} кўриш
                  </span>
                </div>
              ))}
            </div>
          )}
        </>
      )}

      {/* Profile Section */}
      <div style={styles.section}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem', paddingBottom: '0.75rem', borderBottom: '1px solid #e2e8f0' }}>
          <h2 style={{ fontSize: '1.25rem', fontWeight: '600', color: '#1a365d', margin: 0 }}>{t('dashboard.yourProfile')}</h2>
          {!editing && (
            <button
              onClick={startEditing}
              style={{ backgroundColor: '#FFD700', color: '#0d1f17', padding: '0.45rem 1rem', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '0.88rem', fontWeight: '700' }}
            >
              Таҳрирлаш
            </button>
          )}
        </div>

        {/* Hidden file input */}
        <input
          ref={fileInputRef}
          type="file"
          accept="image/jpeg,image/png,image/webp"
          style={{ display: 'none' }}
          onChange={handleAvatarUpload}
        />

        {/* Photo + details row */}
        <div style={{ display: 'flex', gap: '1.5rem', alignItems: 'flex-start', marginBottom: '1.5rem', flexDirection: isMobile ? 'column' : 'row' }}>

          {/* Photo (+ practice areas below it on mobile) */}
          <div style={{ flexShrink: 0, display: 'flex', flexDirection: 'column', gap: '0.75rem', alignItems: 'flex-start', width: isMobile ? '100%' : 'auto' }}>
            <div
              onClick={() => !avatarUploading && fileInputRef.current?.click()}
              onMouseEnter={() => setAvatarHover(true)}
              onMouseLeave={() => setAvatarHover(false)}
              style={{
                width: isMobile ? '110px' : '160px', height: isMobile ? '130px' : '195px', borderRadius: '10px',
                overflow: 'hidden', position: 'relative', cursor: 'pointer',
                border: '3px solid #e2e8f0', backgroundColor: '#f7fafc',
              }}
            >
              {(localPicture || profile?.profile_picture) ? (
                <img
                  src={`${SERVER_URL}${localPicture || profile.profile_picture}`}
                  alt="Фото профиля"
                  style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
                />
              ) : (
                <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#a0aec0' }}>
                  <svg width="56" height="56" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/>
                  </svg>
                </div>
              )}
              <div style={{
                position: 'absolute', inset: 0,
                backgroundColor: 'rgba(0,0,0,0.45)',
                display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
                opacity: (avatarHover || avatarUploading) ? 1 : 0,
                transition: 'opacity 0.2s',
                color: 'white', fontSize: '0.7rem', gap: '0.25rem',
              }}>
                {avatarUploading ? (
                  <span>...</span>
                ) : (
                  <>
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/>
                      <circle cx="12" cy="13" r="4"/>
                    </svg>
                    <span>Изменить</span>
                  </>
                )}
              </div>
            </div>
            {avatarError && (
              <div style={{ fontSize: '0.75rem', color: '#c53030', backgroundColor: '#fed7d7', padding: '0.3rem 0.6rem', borderRadius: '6px', maxWidth: '160px' }}>
                {avatarError}
              </div>
            )}
            {/* Practice areas beside image on mobile */}
            {isMobile && !editing && profile?.practice_areas?.length > 0 && (
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ ...styles.profileLabel, marginBottom: '0.4rem' }}>Мутахассисликлар</div>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.4rem' }}>
                  {getParentCategories(profile.practice_areas).map(parent => (
                    <span key={parent} style={styles.practiceTag}>{parent}</span>
                  ))}
                </div>
              </div>
            )}
          </div>

          {/* Details / Edit form (right side) */}
          <div style={{ flex: 1, minWidth: 0 }}>
            {editing ? (
              <form onSubmit={handleSave} style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                {saveError && (
                  <div style={{ backgroundColor: '#fed7d7', color: '#c53030', padding: '0.75rem 1rem', borderRadius: '8px', fontSize: '0.9rem' }}>
                    {saveError}
                  </div>
                )}

                <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: '1rem' }}>
                  <div>
                    <label style={styles.profileLabel}>Тўлиқ исм *</label>
                    <input name="fullName" style={styles.input} value={editData.fullName} onChange={handleEditChange} required />
                  </div>
                  <div>
                    <label style={styles.profileLabel}>Телефон</label>
                    <PhoneInput value={editData.phone} onChange={val => setEditData(p => ({ ...p, phone: val }))} style={styles.input} />
                  </div>
                  <div>
                    <label style={styles.profileLabel}>Адвокатлик лицензияси *</label>
                    <input name="barNumber" style={styles.input} value={editData.barNumber} onChange={handleEditChange} required />
                  </div>
                  <div>
                    <label style={styles.profileLabel}>Адвокатлик стажи (йил)</label>
                    <input type="number" name="yearsOfExperience" style={styles.input} value={editData.yearsOfExperience} onChange={handleEditChange} min="0" max="70" />
                  </div>
                  <div>
                    <label style={styles.profileLabel}>Ҳудуд *</label>
                    <LocationSelect
                      value={editData.location}
                      onChange={(val) => setEditData(prev => ({ ...prev, location: val }))}
                      inputStyle={styles.input}
                      t={t}
                    />
                  </div>
                </div>

                <div>
                  <label style={styles.profileLabel}>Мутахассисликлар</label>
                  {CASE_CATEGORIES.map(cat => cat.subs.length > 0 && (
                    <div key={cat.label} style={{ marginTop: '0.75rem' }}>
                      <div style={{ fontSize: '0.75rem', fontWeight: '600', color: '#4a5568', marginBottom: '0.4rem' }}>{cat.label}</div>
                      <div style={styles.checkboxContainer}>
                        {cat.subs.map(sub => (
                          <label
                            key={sub}
                            style={{ ...styles.checkboxLabel, ...(editData.practiceAreas.includes(sub) ? styles.checkboxLabelActive : {}) }}
                          >
                            <input type="checkbox" checked={editData.practiceAreas.includes(sub)} onChange={() => togglePracticeArea(sub)} style={{ display: 'none' }} />
                            {sub}
                          </label>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>
              </form>
            ) : (
              <>
                <div style={{ ...styles.profileSection, gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr' }}>
                  <div style={styles.profileItem}>
                    <div style={styles.profileLabel}>{t('dashboard.barNumber')}</div>
                    <div style={styles.profileValue}>{profile?.bar_number || t('dashboard.notSet')}</div>
                  </div>
                  <div style={styles.profileItem}>
                    <div style={styles.profileLabel}>Адвокатлик стажи</div>
                    <div style={styles.profileValue}>{profile?.years_of_experience ? `${profile.years_of_experience} йил` : t('dashboard.notSet')}</div>
                  </div>
                  <div style={styles.profileItem}>
                    <div style={styles.profileLabel}>{t('dashboard.location')}</div>
                    <div style={styles.profileValue}>{profile?.location ? displayLocation(profile.location, t) : t('dashboard.notSet')}</div>
                  </div>
                  <div style={styles.profileItem}>
                    <div style={styles.profileLabel}>{t('dashboard.phoneLabel')}</div>
                    <div style={styles.profileValue}>{profile?.phone || t('dashboard.notSet')}</div>
                  </div>
                </div>
                {!isMobile && profile?.practice_areas?.length > 0 && (
                  <div style={{ marginTop: '1rem' }}>
                    <div style={styles.profileLabel}>Мутахассисликлар</div>
                    <div style={{ ...styles.practiceAreas, marginTop: '0.5rem' }}>
                      {getParentCategories(profile.practice_areas).map(parent => (
                        <span key={parent} style={styles.practiceTag}>{parent}</span>
                      ))}
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
        </div>

        {/* Bio — full width below */}
        {editing ? (
          <>
            <div style={{ marginBottom: '1rem' }}>
              <label style={styles.profileLabel}>Ўзим ҳақимда</label>
              <textarea name="bio" style={styles.textarea} value={editData.bio} onChange={handleEditChange} />
            </div>
            <div style={{ display: 'flex', gap: '0.75rem', justifyContent: 'flex-end' }}>
              <button
                type="button"
                onClick={() => setEditing(false)}
                style={{ padding: '0.6rem 1.25rem', border: '1px solid #e2e8f0', borderRadius: '6px', cursor: 'pointer', fontSize: '0.9rem', backgroundColor: 'white', color: '#4a5568' }}
              >
                Бекор қилиш
              </button>
              <button
                onClick={handleSave}
                disabled={saving}
                style={{ padding: '0.6rem 1.25rem', border: 'none', borderRadius: '6px', cursor: saving ? 'not-allowed' : 'pointer', fontSize: '0.9rem', fontWeight: '700', backgroundColor: saving ? '#a0aec0' : '#FFD700', color: saving ? 'white' : '#0d1f17' }}
              >
                {saving ? 'Сақланяпти...' : 'Сақлаш'}
              </button>
            </div>
          </>
        ) : profile?.bio ? (
          <div style={{ borderTop: '1px solid #e2e8f0', paddingTop: '1rem' }}>
            <div style={styles.profileLabel}>Ўзим ҳақимда</div>
            <p style={{ color: '#4a5568', marginTop: '0.5rem', lineHeight: '1.6' }}>{profile.bio}</p>
          </div>
        ) : null}
      </div>

      {/* Full Info Section */}
      <div style={styles.section}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem', paddingBottom: '0.75rem', borderBottom: '1px solid #e2e8f0' }}>
          <h2 style={{ fontSize: '1.25rem', fontWeight: '600', color: '#1a365d', margin: 0 }}>Мен ҳақимда тўлиқ маълумот</h2>
          {!editingInfo && (
            <button
              onClick={startEditingInfo}
              style={{ backgroundColor: '#FFD700', color: '#0d1f17', padding: '0.45rem 1rem', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '0.88rem', fontWeight: '700' }}
            >
              Таҳрирлаш
            </button>
          )}
        </div>

        {editingInfo ? (
          <form onSubmit={handleSaveInfo} style={{ display: 'flex', flexDirection: 'column', gap: '1.25rem' }}>
            {infoSaveError && (
              <div style={{ backgroundColor: '#fed7d7', color: '#c53030', padding: '0.75rem 1rem', borderRadius: '8px', fontSize: '0.9rem' }}>
                {infoSaveError}
              </div>
            )}

            <div>
              <label style={styles.profileLabel}>Айнан қайси 3 та йўналиш бўйича ўзини мутахассис деб билади</label>
              <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr 1fr', gap: '0.75rem', marginTop: '0.4rem' }}>
                {infoData.specializations.map((val, i) => (
                  <input
                    key={i}
                    style={styles.input}
                    value={val}
                    onChange={e => updateSpecialization(i, e.target.value)}
                    placeholder={`${i + 1}-йўналиш`}
                  />
                ))}
              </div>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: '1rem' }}>
              <div>
                <label style={styles.profileLabel}>Қатнашган суд ишлари сони (охирги 1 йилда)</label>
                <input
                  type="number"
                  min="0"
                  name="courtCasesCount"
                  style={styles.input}
                  value={infoData.courtCasesCount}
                  onChange={handleInfoFieldChange}
                />
              </div>
              <div>
                <label style={styles.profileLabel}>Адвокат бўлишдан олдин иш жойи</label>
                <input
                  name="workplaceBefore"
                  style={styles.input}
                  value={infoData.workplaceBefore}
                  onChange={handleInfoFieldChange}
                />
              </div>
            </div>

            {[
              ['publishedArticles', 'Чоп қилган мақолалари'],
              ['legalAdvice', 'Ҳуқуқий маслаҳатлари, тушинтиришлари'],
              ['socialMediaLinks', 'Ижтимоий тармоқдаги саҳифалари'],
            ].map(([field, label]) => (
              <div key={field}>
                <label style={styles.profileLabel}>{label}</label>
                {infoData[field].map((item, idx) => (
                  <div key={idx} style={{ display: 'flex', gap: '0.5rem', marginTop: '0.5rem', alignItems: 'center', flexWrap: isMobile ? 'wrap' : 'nowrap' }}>
                    <input
                      style={styles.input}
                      placeholder="Сарлавҳа"
                      value={item.title}
                      onChange={e => updateListItem(field, idx, 'title', e.target.value)}
                    />
                    <input
                      style={styles.input}
                      placeholder="Ҳавола (линк)"
                      value={item.link}
                      onChange={e => updateListItem(field, idx, 'link', e.target.value)}
                    />
                    <button
                      type="button"
                      onClick={() => removeListItem(field, idx)}
                      style={{ flexShrink: 0, border: '1px solid #e2e8f0', borderRadius: '6px', backgroundColor: 'white', color: '#c53030', cursor: 'pointer', padding: '0.6rem 0.9rem', fontSize: '0.9rem' }}
                    >
                      ✕
                    </button>
                  </div>
                ))}
                <button
                  type="button"
                  onClick={() => addListItem(field)}
                  style={{ marginTop: '0.5rem', border: '1px dashed #cbd5e0', borderRadius: '6px', backgroundColor: 'white', color: '#3182ce', cursor: 'pointer', padding: '0.5rem 1rem', fontSize: '0.85rem' }}
                >
                  + Қўшиш
                </button>
              </div>
            ))}

            <div style={{ display: 'flex', gap: '0.75rem', justifyContent: 'flex-end' }}>
              <button
                type="button"
                onClick={() => setEditingInfo(false)}
                style={{ padding: '0.6rem 1.25rem', border: '1px solid #e2e8f0', borderRadius: '6px', cursor: 'pointer', fontSize: '0.9rem', backgroundColor: 'white', color: '#4a5568' }}
              >
                Бекор қилиш
              </button>
              <button
                onClick={handleSaveInfo}
                disabled={savingInfo}
                style={{ padding: '0.6rem 1.25rem', border: 'none', borderRadius: '6px', cursor: savingInfo ? 'not-allowed' : 'pointer', fontSize: '0.9rem', fontWeight: '700', backgroundColor: savingInfo ? '#a0aec0' : '#FFD700', color: savingInfo ? 'white' : '#0d1f17' }}
              >
                {savingInfo ? 'Сақланяпти...' : 'Сақлаш'}
              </button>
            </div>
          </form>
        ) : (
          (() => {
            const specs = (profile?.specializations || []).filter(s => s?.trim());
            const lists = [
              ['published_articles', 'Чоп қилган мақолалари'],
              ['legal_advice', 'Ҳуқуқий маслаҳатлари, тушинтиришлари'],
              ['social_media_links', 'Ижтимоий тармоқдаги саҳифалари'],
            ];
            const hasAnything = specs.length || profile?.court_cases_count != null || profile?.workplace_before
              || lists.some(([key]) => profile?.[key]?.length > 0);

            if (!hasAnything) {
              return <p style={{ color: '#718096', fontSize: '0.9rem' }}>Маълумот киритилмаган</p>;
            }

            return (
              <>
                {specs.length > 0 && (
                  <div style={{ marginBottom: '1rem' }}>
                    <div style={styles.profileLabel}>Мутахассислик йўналишлари</div>
                    <div style={styles.profileValue}>{specs.join(', ')}</div>
                  </div>
                )}
                {profile?.court_cases_count != null && (
                  <div style={{ marginBottom: '1rem' }}>
                    <div style={styles.profileLabel}>Қатнашган суд ишлари сони (охирги 1 йилда)</div>
                    <div style={styles.profileValue}>{profile.court_cases_count}</div>
                  </div>
                )}
                {profile?.workplace_before && (
                  <div style={{ marginBottom: '1rem' }}>
                    <div style={styles.profileLabel}>Адвокат бўлишдан олдин иш жойи</div>
                    <div style={styles.profileValue}>{profile.workplace_before}</div>
                  </div>
                )}
                {lists.map(([key, label]) => profile?.[key]?.length > 0 && (
                  <div key={key} style={{ marginBottom: '1rem' }}>
                    <div style={styles.profileLabel}>{label}</div>
                    <ul style={{ paddingLeft: '1.25rem', margin: '0.5rem 0 0' }}>
                      {profile[key].map((it, i) => (
                        <li key={i} style={{ marginBottom: '0.3rem' }}>
                          <a href={it.link} target="_blank" rel="noopener noreferrer" style={{ color: '#3182ce', textDecoration: 'underline' }}>
                            {it.title || it.link}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>
                ))}
              </>
            );
          })()
        )}
      </div>

      {/* Subscription Banner */}
      <div style={{
        ...styles.section,
        ...(subscription?.isSubscribed
          ? { backgroundColor: '#f0fff4', border: '1px solid #38a169' }
          : { backgroundColor: '#fffbeb', border: '1px solid #f59e0b' }),
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <h2 style={{ fontSize: '1.1rem', fontWeight: '600', color: '#1a365d', marginBottom: '0.25rem' }}>Обуна</h2>
            {subscription?.isSubscribed ? (
              <p style={{ color: '#276749', fontSize: '0.9rem', margin: 0 }}>
                ✓ {subscription.tier === 'vip' ? 'VIP' : 'Pro'} — {new Date(subscription.expiresAt).toLocaleDateString('uz-UZ')} гача фаол
                {subscription.tier === 'pro' && ' · VIP\'га юксалтиринг'}
              </p>
            ) : (
              <p style={{ color: '#92400e', fontSize: '0.9rem', margin: 0, marginTop: '0.4rem' }}>Обуна фаол эмас — Pro ёки VIP танланг</p>
            )}
          </div>
          <Link to="/subscription" style={{
            backgroundColor: subscription?.isSubscribed ? '#38a169' : '#FFD700',
            color: subscription?.isSubscribed ? 'white' : '#0d1f17', padding: '0.6rem 1.25rem', borderRadius: '8px',
            textDecoration: 'none', fontSize: '0.9rem', fontWeight: '700',
            minWidth: '120px', textAlign: 'center', flexShrink: 0,
          }}>
            {subscription?.isSubscribed ? (subscription.tier === 'pro' ? 'Юксалтириш' : 'Кўриш') : 'Фаоллаштириш'}
          </Link>
        </div>
      </div>

      {subscription?.tier === 'vip' && (
        <div style={{ ...styles.section, backgroundColor: '#fffbeb', border: '1px solid #f59e0b' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div>
              <h2 style={{ fontSize: '1.1rem', fontWeight: '600', color: '#1a365d', marginBottom: '0.25rem' }}>
                AdvokatTop дан шахсий рейтинг олинг
              </h2>
              <p style={{ color: '#718096', fontSize: '0.9rem', margin: 0 }}>
                Маълумотларингизни тўлдиринг — биз касбий рейтингингизни шакллантирамиз
              </p>
            </div>
            <Link to="/attorney/rating-submission" style={{
              backgroundColor: '#FFD700', color: '#0d1f17', padding: '0.6rem 1.25rem', borderRadius: '8px',
              textDecoration: 'none', fontSize: '0.9rem', fontWeight: '700', minWidth: '120px', textAlign: 'center', flexShrink: 0,
            }}>
              Бошлаш
            </Link>
          </div>
        </div>
      )}

      {/* Client Requests Link */}
      <div style={styles.section}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <h2 style={{ fontSize: '1.1rem', fontWeight: '600', color: '#1a365d', marginBottom: '0.25rem' }}>Мижозлар сўровлари</h2>
            <p style={{ color: '#718096', fontSize: '0.9rem', margin: 0 }}>Адвокат излаётган мижозлар рўйхати</p>
          </div>
          <Link to="/attorney/requests" style={{ backgroundColor: '#FFD700', color: '#0d1f17', padding: '0.6rem 1.25rem', borderRadius: '8px', textDecoration: 'none', fontSize: '0.9rem', fontWeight: '700', minWidth: '120px', textAlign: 'center', flexShrink: 0 }}>
            Кўриш
          </Link>
        </div>
      </div>

      {/* Messages directed to this attorney */}
      <div style={styles.section}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <h2 style={{ fontSize: '1.1rem', fontWeight: '600', color: '#1a365d', marginBottom: '0.25rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
              Менга мурожаатлар
              {unreadMsgCount > 0 && (
                <span style={{ backgroundColor: '#e53e3e', color: 'white', borderRadius: '50%', width: '20px', height: '20px', fontSize: '0.72rem', fontWeight: '700', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                  {unreadMsgCount > 9 ? '9+' : unreadMsgCount}
                </span>
              )}
            </h2>
            <p style={{ color: '#718096', fontSize: '0.9rem', margin: 0 }}>Мижозлардан сизга йўлланган шахсий мурожаатлар</p>
          </div>
          <Link to="/attorney/messages" style={{ backgroundColor: '#FFD700', color: '#0d1f17', padding: '0.6rem 1.25rem', borderRadius: '8px', textDecoration: 'none', fontSize: '0.9rem', fontWeight: '700', minWidth: '120px', textAlign: 'center', flexShrink: 0 }}>
            Кўриш
          </Link>
        </div>
      </div>

      {/* My Articles */}
      <div style={styles.section}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem', paddingBottom: '0.75rem', borderBottom: '1px solid #e2e8f0' }}>
          <h2 style={{ fontSize: '1.25rem', fontWeight: '600', color: '#1a365d', margin: 0 }}>Мақолаларим</h2>
          <Link to="/attorney/articles/new" style={{ backgroundColor: '#FFD700', color: '#0d1f17', padding: '0.45rem 1rem', border: 'none', borderRadius: '6px', textDecoration: 'none', fontSize: '0.88rem', fontWeight: '700' }}>
            + Янги мақола
          </Link>
        </div>

        {articlesLoading ? (
          <div style={styles.emptyState}>Юкланмоқда...</div>
        ) : myArticles.length === 0 ? (
          <div style={styles.emptyState}>Сизда ҳали мақолалар йўқ</div>
        ) : (
          myArticles.map((a) => (
            <div key={a.id} style={{ padding: '0.85rem 0', borderBottom: '1px solid #e2e8f0', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '1rem', flexWrap: 'wrap' }}>
              <div style={{ flex: 1, minWidth: '200px' }}>
                <div style={{ fontWeight: '500', color: '#2d3748', marginBottom: '0.25rem' }}>{a.title}</div>
                <span style={{
                  ...styles.badge,
                  ...(ARTICLE_STATUS_STYLES[a.status] || ARTICLE_STATUS_STYLES.draft),
                }}>
                  {ARTICLE_STATUS_LABELS[a.status] || a.status}
                </span>
                {a.has_pending_edit && (
                  <span style={{ ...styles.badge, ...EDIT_PENDING_STYLE, marginLeft: '0.5rem' }}>
                    Таҳрир кўриб чиқилмоқда
                  </span>
                )}
                {a.status === 'rejected' && a.rejection_reason && (
                  <div style={{ color: '#c53030', fontSize: '0.85rem', marginTop: '0.4rem' }}>
                    Сабаби: {a.rejection_reason}
                  </div>
                )}
                {a.status === 'published' && a.edit_rejection_reason && !a.has_pending_edit && (
                  <div style={{ color: '#c53030', fontSize: '0.85rem', marginTop: '0.4rem' }}>
                    Охирги таҳрир рад этилди: {a.edit_rejection_reason}
                  </div>
                )}
                {a.status === 'published' && a.slug && (
                  <div style={{ marginTop: '0.4rem' }}>
                    <a href={`/legal-topics/${a.slug}`} target="_blank" rel="noopener noreferrer" style={{ color: '#3182ce', fontSize: '0.85rem' }}>
                      Сайтда кўриш →
                    </a>
                  </div>
                )}
              </div>
              <div style={{ display: 'flex', gap: '0.5rem', flexShrink: 0 }}>
                {['draft', 'rejected'].includes(a.status) && (
                  <>
                    <Link to={`/attorney/articles/${a.id}/edit`} style={{ ...styles.subscribeButton, padding: '0.4rem 0.9rem', fontSize: '0.85rem' }}>
                      Таҳрирлаш
                    </Link>
                    <button
                      onClick={() => handleDeleteArticle(a.id)}
                      style={{ backgroundColor: '#fed7d7', color: '#c53030', padding: '0.4rem 0.9rem', border: 'none', borderRadius: '8px', fontWeight: '600', cursor: 'pointer', fontSize: '0.85rem' }}
                    >
                      Ўчириш
                    </button>
                  </>
                )}
                {a.status === 'published' && !a.has_pending_edit && (
                  <Link to={`/attorney/articles/${a.id}/edit`} style={{ ...styles.subscribeButton, padding: '0.4rem 0.9rem', fontSize: '0.85rem' }}>
                    Таҳрирлаш
                  </Link>
                )}
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default AttorneyDashboard;
